module.exports = __webpack_public_path__ + "media/images/logo-67e4723089a625d3966332d8f219c114.png";